import SavedSearch from './SavedSearch';
module.exports = SavedSearch;



// WEBPACK FOOTER //
// ./src/app/SavedSearch/index.js